import * as React from "react";
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';

import {
    getShareConfig,
} from "../../reducers/article";

import './style.css';

interface NoAuthProps {
    location?: any;
    session: { userInfo?: any, isLoggedIn: boolean };
    [propName: string]: any;
}

@(connect(
    ({ session, comment, file }: NoAuthProps) => ({
        session,
        comment,
        file,
    }),
    dispatch =>
        bindActionCreators(
            { getShareConfig },
            dispatch
        )
) as any)
export default class NoAuth extends React.Component<NoAuthProps, any> {
    timeOut: any;

    componentDidMount() {
        // if (/ztobox|ztbox|baohe/.test(navigator.userAgent.toLowerCase())) {
        //     if (global.zt && global.zt.setTitle && global.PageTitle) {
        //         global.zt.setTitle({
        //             title: global.PageTitle,
        //             bgcolor: '#ffffff'
        //         });
        //     }

        //     if (global.zt && global.zt.updateShareContent) {
        //         const shareConfig = {
        //             title: global.PageTitle || '',
        //             desc: global.Title || '',
        //             thumbImageUrl: global.AppIcon || '',
        //             webpageUrl: global.location.href,
        //             timeline: global.Title || '',
        //         };
        //         global.zt.updateShareContent(shareConfig);
        //     }
        // }

        if (this.props.session.isLoggedIn) {
            this.loadShareConfig();
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: NoAuthProps) {
        if (nextProps.session.isLoggedIn && !this.props.session.isLoggedIn) {
            this.loadShareConfig();
        }
    }


    private loadShareConfig() {
        const { location } = this.props;
        const path = location.pathname.split("/");
        const articleId = path[2];

        if (/ztobox|ztbox|baohe/.test(navigator.userAgent.toLowerCase())) {
            this.props.getShareConfig({ articleId });
        }
    }

    render() {
        return <div className="rootWrapper">
            <div className="noAuthContent">对不起，您暂无查看权限</div>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/pages/noAuth/index.tsx